// departmentService.js
import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchDepartment = () => {
  return apiClient(ENDPOINTS.DEPARTMENT, { method: "GET" });
};

export const createDepartemnt = (departmentData) => {
  return apiClient(
    ENDPOINTS.DEPARTMENT,
    { method: "POST", body: departmentData },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const updateDepartment = (id, departmentData) => {
  return apiClient(
    `${ENDPOINTS.DEPARTMENT}/${id}`,
    { method: "PUT", body: departmentData },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const deleteDepartment = async (departmentId) => {
  return await apiClient(`${ENDPOINTS.DEPARTMENT}/${departmentId}`, {
    method: "DELETE",
  });
};
